import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isOpen: false,
    severity: "",
    message: ""
};

const showAlertSlice = createSlice({
    name: "showAlert",
    initialState,
    reducers: {
        showAlertPopup: (state, action) => {
            const { severity, message } = action.payload || {};

            // Prevent duplicate identical alerts from stacking
            if (state.isOpen && state.message === message && state.severity === severity) {
                return state;
            }

            return {...state, isOpen: true, severity, message, id: Date.now() };
        },

        hideAlertPopup: () => initialState
    }
});

export const { showAlertPopup, hideAlertPopup } = showAlertSlice.actions;

export default showAlertSlice.reducer;